import { createSelector } from 'reselect';
import { initialState } from './reducer';
export var dataDomain = function (state) { return state.data || initialState; };
export var selectAppId = createSelector(dataDomain, function (domain) { return domain.appId || initialState.appId; });
export var selectDatasets = createSelector(dataDomain, function (domain) { return domain.datasets || []; });
export var selectStates = createSelector(dataDomain, function (domain) { return domain.states || []; });
export var selectViews = createSelector(dataDomain, function (domain) { return domain.views || []; });
export var selectCustomLogics = createSelector(dataDomain, function (domain) { return domain.customLogics || []; });
export var selectPermissions = createSelector(dataDomain, function (domain) { return domain.permissions || []; });
export var selectContextMenuPosition = createSelector(dataDomain, function (domain) { return domain.contextMenuPosition; });
